<!-- 机票航程  仓位列表 订单填写弹出层  订单详情 改签退票详情 展示  -->
<template>
  <div class="full-width list-date white">
    <van-row
      type="flex"
      align="center"
      class="headerDate"
    >
      <van-col
        v-if="(tkSearchInfo.queryStrWF.travelType == 1 && tkSearchInfo.roundtrip == 0 && dateInfo.date != formatDate(new Date()).date) || (tkSearchInfo.queryStrWF.travelType == 2 && tkSearchInfo.roundtrip == 0 && dateInfo.date != formatDate(new Date()).date) || (tkSearchInfo.queryStrWF.travelType == 2 && tkSearchInfo.roundtrip == 1 && dateInfo.date > tkSearchInfo.flights[0].departDate)"
        :span="6"
        @click="$emit('prevDay',-1)"
        
      >
        <ld-icon type="iconleft" />
        {{ $t('F213','前一天') }}
      </van-col>
      <van-col
        :span="showNext?12:24"
        class="text-center now bg-main"
        @click="$emit('toggle',1)"
      >
        <slot name="date">
          {{ dateInfo.monDay }} {{ dateInfo.week }}
          <img
            width="22"
            src="~Assets/images/tr/train_date_down.png"
          >
        </slot>
      </van-col>
      <van-col
        v-show="showNext"
        :span="6"
        class="text-right"
        @click="$emit('afterDay',1)"
      >
        {{ $t('F214','后一天') }}
        <ld-icon type="iconright" />
      </van-col>
    </van-row>
  </div>
</template>

<script>
import {Icon} from 'vant'
import {formatDate} from 'Utils/dateUtil'
import {mapGetters} from 'vuex'
export default {
  name:'ListDate',
  props:{
    dateInfo:{//航班信息
      type:[Object],
      required: true,
      default: function () {
        return {
          monDay:'',
          week:''
        }
      }
    },
    showNext:{
      type:Boolean,
      default:true
    }
  },
  components: {
    [Icon.name]:Icon,
  },
  data(){
    return {
    }
  },
  created(){
    console.log(this.dateInfo,'4545454')
  },
  computed: {
    ...mapGetters({
      tkSearchInfo: 'tk/tkSearchInfo'
    })
  },
  methods:{
    formatDate,
  },
  filters:{
  }
}
</script>

<style  lang="less" scoped>
.list-date {
  font-size: @font-size-14;
  padding: 6px 16px;
  background-color: transparent;
  .now {
    height: 34px;
    line-height: 34px;
    border-radius: 18px;
    img {
      margin-left: 5px;
      vertical-align: middle;
    }
  }
  .headerDate {
      justify-content: flex-end !important;
  }
}
</style>
